import styles from './FormContent.module.scss';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function FormContent(props: Props) {
  return <div className={styles['form-content']}>{props.children}</div>;
}
